<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import DashboardBox from "@/Components/Common/Helpers/DashboardBox.vue";
import MediaUpload from "../../Components/Common/Media/MediaUpload.vue";
import {useHelpers} from "../../helpers";
import {usePage} from "@inertiajs/inertia-vue3";

defineProps({
  media: Object
});
const helpers = useHelpers();
const currentUser = usePage().props.value.auth.user;
</script>

<template>
  <AppLayout title="Production">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Production
      </h2>
    </template>

    <div class="max-w-full py-10 sm:px-6 lg:px-8">
      <div class="grid grid-cols-2 gap-1 md:grid-cols-3 md:gap-2 lg:grid-cols-6 lg:gap-3 mb-5">
        <DashboardBox :href="route('production.companies.index')"
                      class="lg:col-start-3"
                      label="Companies" icon="building"></DashboardBox>
        <DashboardBox :href="route('admin.workorders.index')"
                      label="Your Open Workorders" icon="folder-open"></DashboardBox>
      </div>


      <MediaUpload
        :media-input="media"
        :can-see-upload-form="helpers.userHasPermission(currentUser, 'admin')"
        :can-modify-media-details="helpers.userHasPermission(currentUser, 'admin')"
        :hide-save="false"
        media-location="production"
      ></MediaUpload>
    </div>
  </AppLayout>
</template>
